"use client";

import React, { useEffect, useRef } from 'react';

const testimonials = [
  {
    name: '張偉強',
    role: '廣州某連鎖超市採購總監',
    company: '廣州美家生活超市',
    quote: '與信悅合作已有五年，他們的日用品品類齊全，工廠直供價格有競爭力，每次到貨都很及時，是我們最穩定的供應商之一。',
    rating: 5,
    avatar: 'ZW',
  },
  {
    name: '林曉燕',
    role: '電商運營負責人',
    company: '杭州某跨境電商公司',
    quote: '信悅的母嬰用品系列在我們的獨立站上銷量非常好，品質穩定，包裝精美，客戶反饋一直很好。OEM定制服務也很專業。',
    rating: 5,
    avatar: 'LX',
  },
  {
    name: '陳建國',
    role: '批發商',
    company: '上海日用品批發中心',
    quote: '上海本地的供應商，溝通效率很高，廚房用具的品質超出預期，小家電類目的性價比也很高，已介紹多位同行合作。',
    rating: 5,
    avatar: 'CJ',
  },
];

export default function TestimonialsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('reveal-hidden');
          }
        });
      },
      { threshold: 0.1 }
    );
    sectionRef?.current?.querySelectorAll('.reveal')?.forEach((el) => {
      el?.classList?.add('reveal-hidden');
      observer?.observe(el);
    });
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 px-6 bg-white">
      <div className="max-w-container mx-auto">
        <div className="text-center mb-14 reveal">
          <p className="text-xs font-semibold tracking-widest uppercase text-accent mb-2">
            PARTNERS SAY · 合作夥伴評價
          </p>
          <h2 className="font-heading font-bold text-brand-fg" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
            他們選擇信悅
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-7">
          {testimonials?.map((t, i) => (
            <div
              key={t?.name}
              className="reveal rounded-3xl border border-brand-border p-8 bg-secondary/30 flex flex-col justify-between hover:border-primary/30 hover:shadow-card transition-all duration-300"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div>
                <div className="flex gap-1 mb-5">
                  {Array.from({ length: t?.rating })?.map((_, j) => (
                    <span key={j} className="text-accent text-base">★</span>
                  ))}
                </div>
                <p className="text-brand-fg/80 leading-relaxed italic text-sm mb-6">
                  "{t?.quote}"
                </p>
              </div>
              <div className="flex items-center gap-3 pt-4 border-t border-brand-border">
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-white text-sm flex-shrink-0"
                  style={{ background: 'linear-gradient(135deg, #8B5E3C, #C4915A)' }}
                >
                  {t?.avatar}
                </div>
                <div>
                  <p className="font-semibold text-brand-fg text-sm">{t?.name}</p>
                  <p className="text-xs text-brand-muted">{t?.role}</p>
                  <p className="text-xs text-accent">{t?.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}